export default function LegalPage({ title, testId, children }) {
  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-16" data-testid={testId}>
      <h1 className="text-3xl sm:text-4xl font-display font-medium text-slate-900 mb-8">{title}</h1>
      <div className="prose-sm text-sm text-slate-600 leading-relaxed space-y-5">{children}</div>
    </div>
  );
}
